import styled from '@emotion/styled/macro'
import { FormStack } from 'forms/FormStack'
import { useCurrentFormik } from 'hooks/useCurrentFormikContext'
import { useSelection } from 'hooks/useSelection'
import { uniq } from 'lodash'
import { Proving } from 'model'
import { Label, Stack, Text } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'react-router5'
import { getPersonDisplayName } from 'views/helpers'
import { MyProvingList } from 'views/MyProvingIndexView/MyProvingList'

const StyledSectionTitle = styled.div`
  padding: 15px 0 3px 0;
  border-bottom: 1px solid;
`

export const PersonForm: React.FC<{ items: any }> = ({ items }) => {
  const { t } = useTranslation()
  const formikContext = useCurrentFormik()
  const router = useRouter()
  const initialValues = formikContext ? formikContext.initialValues : undefined
  const [selection] = useSelection<any>({
    getKey: (item) => item!._id!,
  })
  const showProving = React.useCallback(
    (proving: Partial<Proving>) => {
      router.navigate('provings.details', { id: proving.id })
    },
    [router]
  )
  let relevantProvings: any[] = []
  items.forEach((i: any) => {
    i.participants.forEach((p: any) => {
      if (p.person && p.person._id && p.person._id === initialValues._id) {
        relevantProvings.push(i)
      }
    })
  })
  relevantProvings = uniq(relevantProvings)

  const showSelectedProving = React.useCallback(
    (proving: any) => {
      const curProving = proving as any
      showProving({
        ...curProving,
      })
    },
    [showProving]
  )

  return (
    <FormStack>
      <StyledSectionTitle>
        <Text variant="xLarge" as="h2">
          {t('Person')}
        </Text>
      </StyledSectionTitle>
      <Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Typ')}:</Label>
          <Label>{getPersonDisplayName(initialValues, t)}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Nachname')}:</Label>
          <Label>{initialValues.lastName}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Vorname')}:</Label>
          <Label>{initialValues.firstName}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Firma')}:</Label>
          <Label>{initialValues.company || initialValues.companyName}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('E-Mailadresse')}:</Label>
          <Label>{initialValues.email}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Abteilung')}:</Label>
          <Label>{initialValues.department}</Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Personalnummer')}:</Label>
          <Label>
            {initialValues.employeeId
              ? initialValues.employeeId
              : initialValues._id &&
                initialValues._id.length &&
                initialValues._id.length < 20
              ? initialValues._id
              : ''}
          </Label>
        </Stack>
        <Stack horizontal={true} tokens={{ childrenGap: 12 }}>
          <Label>{t('Anmerkungen')}:</Label>
          <Label>{initialValues.annotation}</Label>
        </Stack>
      </Stack>
      <StyledSectionTitle>
        <Text variant="xLarge" as="h2">
          {t('Buchungen')}
        </Text>
      </StyledSectionTitle>
      <MyProvingList
        items={relevantProvings}
        selection={selection}
        onItemInvoked={showSelectedProving}
      />
    </FormStack>
  )
}
